import {
    IDeviceInformation, IDeviceItemGrouping, IDeviceItemVisitor, IDeviceNode,
    IDynamicControlsSharedState
} from '../shared/models/device';

import { DeviceService } from '../shared/services/device.service';
import { DeviceCategory } from '../shared/models/device-category';
import { ElementTypes } from '../shared/models/models';

export class DynamicCalendarTabVisitor implements IDeviceItemVisitor {
    public service: DeviceService;
    public currentGrouping: IDeviceItemGrouping;

    public init(
        rootNode: IDeviceNode,
        device: IDeviceInformation,
        sharedState: IDynamicControlsSharedState
    ) {
        // empty
    }

    public canVisit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): boolean {
        return this.isRoot(owningObject) && this.isDynamicCalendar(propValue);
    }

    public visit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): IDeviceItemGrouping {
        let category = new DeviceCategory(propValue);

        propValue.$isContainer = true;
        propValue.displayText = '';

        this.currentGrouping.$selectedCategory = 0;
        this.currentGrouping.$categories.push(category);

        return category; // Make current grouping.
    }

    private isRoot(node: IDeviceNode) {
        return node.elementType === ElementTypes.Root;
    }

    private isDynamicCalendar(node: IDeviceNode) {
        return node.elementType === ElementTypes.DynamicCalendar;
}
}
